<template>
	<v-dialog v-model="dialog" persistent max-width="500px">
		<v-card>
			<v-form>
				<v-toolbar flat dense cad class="primary" dark>
					<v-icon color="red">
						location_on
					</v-icon>
					<v-toolbar-title class="subheading">{{ meetingLocation.name }}</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>

				<v-divider></v-divider>
				<v-card-text>
					<v-list two-line>
						<v-list-tile>
							<v-list-tile-content>
								<v-list-tile-title>{{ locationDescription }}</v-list-tile-title>
								<v-list-tile-sub-title>Location Description</v-list-tile-sub-title>
							</v-list-tile-content>
						</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile>
							<v-list-tile-content>
								<v-list-tile-title>{{ getMeetingLocationType(meetingLocation.type) }}</v-list-tile-title>
								<v-list-tile-sub-title>Location Type</v-list-tile-sub-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @click="closeEditor">Close</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
	import typeFriendlyMixin from '@/mixins/typeFriendlyMixin';

	export default {
		props: {
			meetingLocation: {
				type: Object,
				required: true
			},
			dialog: {}
		},
		computed: {
			locationDescription() {
				return this.meetingLocation.description !== null ? this.meetingLocation.description : 'N/A';
			}
		},
		mixins: [typeFriendlyMixin],

		methods: {
			closeEditor() {
				this.$emit('closeEditor');
			}
		}
	};
</script>

<style></style>
